var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"checkbox",on:{"click":function($event){return _vm.$emit('change')}}},[_c('Icon',{staticClass:"checkbox",attrs:{"name":_vm.checked ? 'checkbox-on' : 'checkbox-off',"size":"32"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }